import { createContext } from 'react';

type TourCalendarContextType = {
  canRescheduleTours?: boolean;
  listingAlias?: string;
  listingAddress?: string;
  propertyPhotoUrl?: string;
  refetchTouringData?: () => void;
};

const TourCalendarContext = createContext<TourCalendarContextType>({
  canRescheduleTours: false,
  listingAlias: '',
  listingAddress: '',
  propertyPhotoUrl: '',
  refetchTouringData: () => {},
});

export default TourCalendarContext;
